import {CSSProperties, StyleDeclarationMap} from '../../../styleSheet';
import {StyleCategoryName} from '../types';
import {buildBorderStyle} from './buildBorderStyle';
import {buildFlexDirectionStyle} from './buildFlexDirectionStyle';
import {buildFlexStyle} from './buildFlexStyle';
import {buildFontStyle} from './buildFontStyle';
import {buildOverflowStyle} from './buildOverflowStyle';
import {buildPaddingStyle} from './buildPaddingStyle';
import {buildPointerEventsStyle} from './buildPointerEventsStyle';
import {buildPositionStyle} from './buildPositionStyle';
import {buildShadowStyle} from './buildShadowStyle';
import {buildSizeStyle} from './buildSizeStyle';
import {buildVisibilityStyle} from './buildVisibilityStyle';
import {getStaticDefaultPositionStyle} from './getStaticDefaultPositionStyle';

type StyleCategoryMapType = {
  [style in StyleCategoryName]: {
    dynamicPropFactory: <TProps>(
      props: TProps,
    ) => CSSProperties | StyleDeclarationMap | undefined;
    defaultStyleFactory?: () => CSSProperties | StyleDeclarationMap;
  };
};

export const StyleCategoryMap: StyleCategoryMapType = {
  font: {
    dynamicPropFactory: buildFontStyle,
  },
  padding: {
    dynamicPropFactory: buildPaddingStyle,
  },
  border: {
    dynamicPropFactory: buildBorderStyle,
  },
  size: {
    dynamicPropFactory: buildSizeStyle,
  },
  position: {
    dynamicPropFactory: buildPositionStyle,
    defaultStyleFactory: getStaticDefaultPositionStyle,
  },
  flexDirection: {
    dynamicPropFactory: buildFlexDirectionStyle,
  },
  flex: {
    dynamicPropFactory: buildFlexStyle,
  },
  visibility: {
    dynamicPropFactory: buildVisibilityStyle,
  },
  pointerEvents: {
    dynamicPropFactory: buildPointerEventsStyle,
  },
  shadow: {
    dynamicPropFactory: buildShadowStyle,
  },
  overflow: {
    dynamicPropFactory: buildOverflowStyle,
  },
};
